<template>
    <div class="projectItem">
        <div class="left">
            <div>
                <span>{{ title }}</span>
                <span>{{ date }}</span>
            </div>
            <div>
                <img src="../../assets/icons/git.png" alt="logo" />
                <a :href="git">Github</a>
            </div>
            <div>
                <a :href="site" target="_blank">
                    <img v-bind:src="require('../../assets/project/' + img)" alt="photo" />
                </a>
            </div>
        </div>
        <div class="right">
            <p>{{ type }}</p>

            <div class="desc">
                <p>What I did</p>
                <pre>{{ what }}</pre>
            </div>
            <div class="desc">
                <p>Stack</p>
                <p>{{ stack }}</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["title", "date", "img", "git", "type", "what", "stack", "site"],
};
</script>
<style>
.projectItem::after {
    content: "";
    display: block;
    clear: both;
}
.projectItem > div {
    float: left;
}
.left {
    margin-left: 40px;
}
.left > div:first-child {
    padding-bottom: 4px;
    margin: 0 50px;
    border-bottom: 2px solid black;
}
.left > div:nth-child(2) {
    margin: 10px 50px 20px;
    text-align: left;
}
.left > div:nth-child(2) > img {
    width: 36px;
    vertical-align: middle;
}
.left > div:nth-child(2) > a {
    text-decoration: none;
    color: black;
    vertical-align: middle;
}
.left > div:nth-child(3) > img {
    width: 540px;
}
.left > div > span:first-child {
    font-size: 1.3em;
    font-weight: 900;
    margin-right: 10px;
}
.right {
    margin-top: 72px;
    margin-left: 80px;
}
.right pre {
    line-height: 1.3;
}
.desc > p:first-child {
    font-size: 1.1em;
    font-weight: 700;
    border-bottom: 2px solid black;
    width: 160px;
}
</style>
